(function (angular) {
    'use strict';

    angular.module('app')
        .service('MemberPackages', memberPackages);

    memberPackages.$inject = [
        'modalService',
        'UsersApi',
        'Users',
    ];

    function memberPackages(
        modalService,
        UsersApi,
        Users
    ) {
        function buyMemberPackage(memberPackageId) {
            return modalService.open({
                templateUrl: 'modals/buy-member-package.html',
                controllerAs: 'vm',
                controller: 'buyMemberPackageController',
                windowClass: 'buy-member-package',
                resolve: {
                    memberPackageId: function () {
                        return memberPackageId;
                    }
                }
            });
        }

        /**
         * Opens a modal allowing a user to create or edit a member package
         * @param  {int} ?memberPackageId - ID of member package
         * @return {object} - modalService containing result.then
         */
        function manageMemberPackage(memberPackageId) {
            return modalService.open({
                templateUrl: 'modals/manage-member-package.html',
                controller: 'manageMemberPackageController',
                windowClass: 'manage-page',
                resolve: {
                    memberPackageId: function () {
                        return memberPackageId;
                    }
                }
            });
        }

        return {
            buy: buyMemberPackage,
            create: manageMemberPackage,
            edit: manageMemberPackage
        };
    }

}(angular));
